import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const AddContentType = ({ onClose, getData, id }) => {
  const [generationPrompt, setGenerationPrompt] = useState("");
  const [validationPrompt, setValidationPrompt] = useState("");
  const [contentType, setContentType] = useState("");
  const [isQuestion, setIsQuestion] = useState(null);
  // const [useSeo, setUseSeo] = useState(0);

  const saveContentType = async () => {
    const editPayload = {
      generation_prompt: generationPrompt,
      validation_prompt: validationPrompt,
      id: id,
    };

    const createPayload = {
      content_type: contentType,
      generation_prompt: generationPrompt,
      validation_prompt: validationPrompt,
      is_question: isQuestion,
      // use_seo: useSeo ? 1 : 0,
      fullname: localStorage.getItem("fullname"),
      email: localStorage.getItem("email"),
    };

    try {
      if (id !== 0) {
        await axios.put(`${process.env.REACT_APP_API_URL}/scribe-bot-settings`, editPayload);
        toast.success("Edited successfully");
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/scribe-bot-settings`, createPayload);
        toast.success(
          `Your request for the ${contentType} content type has been submitted successfully. Once an engineer verifies the content type with the generation flow, it will be approved and you will receive a confirmation email.`,
        );
      }
      getData();
      onClose();
    } catch (err) {
      toast.error("Failed to save content type.");
      console.error("Error saving content type:", err);
    }
  };

  const getDataById = () => {
    if (id !== 0) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/scribe-bot-settings?id=${id}`)
        .then((res) => {
          const data = res.data.data[0];
          setContentType(data.content_type || "");
          setGenerationPrompt(data.default_generation_prompt || "");
          setValidationPrompt(data.default_validation_prompt || "");
          setIsQuestion(data.is_question ?? null);
          // setUseSeo(!!data.use_seo);
        })
        .catch((e) => {
          console.error(e.message);
        });
    }
  };

  useEffect(() => {
    getDataById();
  }, []);

  return (
    <Modal show onHide={onClose} centered size="xl" style={{ zIndex: 10000 }}>
      <Modal.Header closeButton>
        <Modal.Title>{id !== 0 ? "Edit Prompt" : "Add Content Type"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-4">
            <Col md={6} hidden={id !== 0}>
              <Form.Group controlId="isQuestion">
                <Form.Label>Is Question Type?</Form.Label>
                <div className="d-flex gap-3 mt-2">
                  <Form.Check
                    type="radio"
                    id="isQuestionYes"
                    label="Yes"
                    name="isQuestion"
                    value={1}
                    checked={isQuestion === 1}
                    onChange={(e) => setIsQuestion(Number(e.target.value))}
                  />
                  <Form.Check
                    type="radio"
                    id="isQuestionNo"
                    label="No"
                    name="isQuestion"
                    value={0}
                    checked={isQuestion === 0}
                    onChange={(e) => setIsQuestion(Number(e.target.value))}
                  />
                </div>
              </Form.Group>

              {/* {isQuestion === 0 && (
                <Form.Group controlId="useSeo" className="mt-4">
                  <Form.Label>Use SEO</Form.Label>
                  <Form.Check
                    type="checkbox"
                    label="Enable SEO"
                    checked={useSeo}
                    onChange={() => setUseSeo(useSeo == 1 ? 0 : 1)}
                  />
                </Form.Group>
              )} */}
            </Col>

            <Col md={6}>
              <Form.Group controlId="contentType" hidden={id !== 0}>
                <Form.Label>Content Type</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter content type..."
                  value={contentType}
                  onChange={(e) => setContentType(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3" controlId="generationPrompt">
            <Form.Label>Generation Prompt</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Enter generation prompt..."
              value={generationPrompt}
              onChange={(e) => setGenerationPrompt(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="validationPrompt">
            <Form.Label>Validation Prompt</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Enter validation prompt..."
              value={validationPrompt}
              onChange={(e) => setValidationPrompt(e.target.value)}
            />
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="primary"
              onClick={saveContentType}
              disabled={
                !generationPrompt.trim() ||
                !validationPrompt.trim() ||
                !contentType.trim() ||
                isQuestion === null
              }
            >
              Save
            </Button>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddContentType;
